import React from "react";
import HeaderComponent from "../HeaderComponent/HeaderComponent";
import videoUrl from "../../fifthAssets/Images/video.mp4";

const Method = (props) => {
    const { selectedLanguage } = props;
    return (
        <div>
            <HeaderComponent title={selectedLanguage?.txt_our_method} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-method-video-player">
                <video controls>
                    <source src={videoUrl} type="video/mp4" />
                    <source src="movie.ogg" type="video/ogg" />
                </video>
            </div>
        </div>
    );
}

export default Method;
